import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getAllocations: {
        method: 'GET',
        url: `${BASE_PATH_API}/properties/:propertyId/allocations`,
        params: {
            '$count': true
        }
    },
    deleteAllocation: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/commonAllocations/:id`
    },
    getAllocationByAllocationId: {
        method: 'GET',
        url: `${BASE_PATH_API}/commonAllocations/:allocationId`
    },
    getCommonAllocationDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/properties/:propertyId/commonAllocations/units`
    },
    createCommonAllocation: {
        method: 'POST',
        url: `${BASE_PATH_API}/commonAllocations`
    },
    updateCommonAllocation: {
        method: 'PUT',
        url: `${BASE_PATH_API}/commonAllocations/:id`
    }
};

export function CommonAllocationsApi() {
    return createActions(actions);
}
